import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight'
import Link from '@mui/material/Link'
import MuiBreadcrumbs, { BreadcrumbsProps as MuiBreadcrumbsProps } from '@mui/material/Breadcrumbs'
import Typography from '@mui/material/Typography'
import NextLink from 'next/link'
import Box from '@mui/material/Box'
import Icon from '@/components/icons/Icon'
import { BreadcrumbItem } from '@/interfaces/pages'

interface BreadcrumbsProps extends MuiBreadcrumbsProps {
  breadcrumbs: BreadcrumbItem[]
}

export const Breadcrumbs = ({ breadcrumbs, ...props }: BreadcrumbsProps): React.ReactElement => {
  return (
    <MuiBreadcrumbs
      {...props}
      separator={<Icon icon={faAngleRight} />}
      itemScope
      itemType="https://schema.org/BreadcrumbList"
    >
      {breadcrumbs.map((breadcrumb, index) =>
        breadcrumb.href ? (
          <Box itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem" key={breadcrumb.label}>
            <NextLink href={breadcrumb.href} passHref legacyBehavior prefetch={false}>
              <Link underline="hover" itemProp="item">
                <Box component="span" itemProp="name" whiteSpace="nowrap">
                  {breadcrumb.label}
                </Box>
              </Link>
            </NextLink>
            <meta itemProp="position" content={`${index + 1}`} />
          </Box>
        ) : (
          <Box itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem" key={breadcrumb.label}>
            <Typography variant="breadcrumbItem" itemProp="name" sx={{ wordBreak: 'break-all' }}>
              {breadcrumb.label}
            </Typography>
            <meta itemProp="position" content={`${index + 1}`} />
          </Box>
        )
      )}
    </MuiBreadcrumbs>
  )
}
